console.log('Loaded Custom Product');

document.addEventListener('DOMContentLoaded', function(){
    var bundle_form = document.querySelector('.product-bundle__form');

    if(typeof bundle_form !== 'undefined' && bundle_form != null) {
        var radios = document.querySelectorAll('.product-bundle-form__option input');
        var active = document.querySelector('.product-bundle-form-wrapper > .active');
        var addButton = document.querySelector('.product-bundle__form button');

        radios.forEach(function(el){
            el.addEventListener('change', function(e){
                active.classList.remove('active');
                active = this.parentElement.parentElement;
                active.classList.add('active');
            });
        });

        bundle_form.addEventListener('submit', function(e){
            e.preventDefault();
            var productId = document.querySelector('#product_bundle_id').value;
            var oilVariant = document.querySelector('#fragance-option');
            
            addButton.innerText = "ADDING TO CART";
            addButton.disabled = true;
            let formData = {
                'items': [{
                    'id': productId,
                    'quantity': 1
                },
                {
                    'id': oilVariant.value,
                    'quantity': 1,
                    'selling_plan': oilVariant.options[oilVariant.selectedIndex].dataset.sellingPlan
                }]
            };
            
            fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            })
            .then(response => {
                return response.json();
            })
            .then(data =>{
                addButton.innerText = "ADD TO CART";
                addButton.disabled = false;
                window.location.replace(window.Shopify.routes.root + "cart");
            })
            .catch((error) => {
                addButton.innerText = "ADD TO CART";
                addButton.disabled = false;
                console.error('Error:', error);
            });
               

        });
    }
});